import QuestionTooltip from './QuestionTooltip';

export default QuestionTooltip;
